import Model, { ID, MODEL_LEVEL } from 'src/models/model'

export default class CustomerioBroadcast extends Model {
  static name = 'CustomerioBroadcast'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      }
    }
  }
}
